export const DELETE_MACHINE_FAIL = 'DELETE_MACHINE_FAIL';
export const DELETE_MACHINE_REQUEST = 'DELETE_MACHINE_REQUEST';
export const DELETE_MACHINE_SUCCESS = 'DELETE_MACHINE_SUCCESS';

export const GET_MACHINE_DETAILS_INFORMATION_REQUEST =
  'GET_MACHINE_DETAILS_INFORMATION_REQUEST';
export const GET_MACHINE_DETAILS_INFORMATION_SUCCESS =
  'GET_MACHINE_DETAILS_INFORMATION_SUCCESS';
export const GET_MACHINE_DETAILS_INFORMATION_FAIL =
  'GET_MACHINE_DETAILS_INFORMATION_FAIL';

export const UPDATE_MACHINE_DETAILS_REQUEST = 'UPDATE_MACHINE_DETAILS_REQUEST';
export const UPDATE_MACHINE_DETAILS_SUCCESS = 'UPDATE_MACHINE_DETAILS_SUCCESS';
export const UPDATE_MACHINE_DETAILS_FAIL = 'UPDATE_MACHINE_DETAILS_FAIL';

export const LIST_MACHINE_SUGGESTION_REQUEST =
  'LIST_MACHINE_SUGGESTION_REQUEST';
export const LIST_MACHINE_SUGGESTION_SUCCESS =
  'LIST_MACHINE_SUGGESTION_SUCCESS';
export const LIST_MACHINE_SUGGESTION_FAIL = 'LIST_MACHINE_SUGGESTION_FAIL';

export const UPDATE_MACHINE_GEOFENCE_REQUEST =
  'UPDATE_MACHINE_GEOFENCE_REQUEST';
export const UPDATE_MACHINE_GEOFENCE_SUCCESS =
  'UPDATE_MACHINE_GEOFENCE_SUCCESS';
export const UPDATE_MACHINE_GEOFENCE_FAIL = 'UPDATE_MACHINE_GEOFENCE_FAIL';

export const RESET_MY_MACHINE_DETAILS_STATE = 'RESET_MY_MACHINE_DETAILS_STATE';
